import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ContentWrapper = styled.div`
  border-radius: var(--size-border-radius-md);
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
`;

const ContactHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export { ContactHeader, Content, ContentWrapper };
